import firebase from "../firebase"

export default function getHttpsCallableWithOptions (
  name: string,
  options: firebase.functions.HttpsCallableOptions,
): (val: any) => Promise<any> {
  return process.env.REACT_APP_BUILD_ENV === "localhost"
    ? firebase  // eslint-disable-line import/no-named-as-default-member
      .functions()
      .httpsCallable(name, options)
    : firebase
      .app()
      .functions("europe-west1")
      .httpsCallable(name, options)
}
